// Luxe · Start Design — Amber-inspired empty state shown before the
// project has any design items on the canvas. Reserves clear future
// insertion points for Design Templates, Inspiration Library and AI
// Suggested Designs without shipping fake functionality. Only Blank
// Design is active in this phase; the other two are intentionally
// disabled with a "Coming later" label.
import { Sparkles, LayoutTemplate, PencilRuler } from "lucide-react";

export default function StartDesignEmptyState({ onStartBlank, onStartFromTemplate }) {
  return (
    <div className="luxe-card p-8 lg:p-12"
         data-testid="start-design-empty-state">
      <div className="max-w-3xl">
        <div className="overline text-[10px] text-muted-foreground">Start</div>
        <h3 className="font-serif font-light mt-2" style={{ fontSize: "28px", lineHeight: 1.1 }}>
          Start a design
        </h3>
        <p className="text-sm text-muted-foreground mt-3 max-w-xl">
          Design the media wall from a blank canvas, choose a curated template, or (soon) start from an AI concept. You can always adjust every dimension, material and finish later.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-3 mt-8">
        <button type="button"
                data-testid="btn-start-blank-design"
                onClick={onStartBlank}
                className="text-left border border-foreground p-5 bg-foreground text-background hover:bg-foreground/90 transition-colors">
          <PencilRuler className="w-5 h-5 mb-4" strokeWidth={1.5}/>
          <div className="font-serif text-lg leading-tight">Blank design</div>
          <div className="text-xs opacity-80 mt-2">Open the design workspace with an empty wall and start placing components.</div>
        </button>

        <button type="button"
                data-testid="btn-start-from-template"
                onClick={onStartFromTemplate}
                className="text-left border border-foreground/60 p-5 bg-background hover:bg-muted/60 transition-colors relative">
          <LayoutTemplate className="w-5 h-5 mb-4" strokeWidth={1.5}/>
          <div className="font-serif text-lg leading-tight">Start from template</div>
          <div className="text-xs text-muted-foreground mt-2">Choose from ten curated media walls — Subtend Studio will adapt one to your wall dimensions.</div>
        </button>

        <div data-testid="btn-start-ai-suggested"
             aria-disabled="true"
             className="text-left border border-border p-5 bg-muted/40 text-muted-foreground cursor-not-allowed relative">
          <Sparkles className="w-5 h-5 mb-4" strokeWidth={1.5}/>
          <div className="font-serif text-lg leading-tight">AI suggested design</div>
          <div className="text-xs mt-2">Describe the brief and let Subtend Studio propose a starting layout you can refine.</div>
          <div className="text-[10px] uppercase tracking-widest mt-4 inline-block border border-border px-2 py-0.5">Coming later</div>
        </div>
      </div>
    </div>
  );
}
